import React, { useState, useEffect, Suspense } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { compose } from 'redux';
import { connect } from 'react-redux';
import {
  Navigate,
} from 'react-router';
import {
  useLocation,
  useNavigate,
  Route,
  Routes,
} from 'react-router-dom';

import Page404 from './Page404';
import DialogManager from './DialogManager';
import { logout } from '../actions/auth';
import Login from './Login';
import ResetPassword from '../components/ResetPassword';
import Notifications from '../components/Notifications';
import Header from './Header.js';
import customTheme from '../config/customTheme';
import routers from '../config/router';
import LoadingManager from './LoadingManager';
import withMediaQuery from '../components/Hoc/WithMediaQuery';
import store from '../store.js';
import { setLoading } from '../actions/loading.js';


const defaultTheme = createTheme();
const theme = createTheme(customTheme(defaultTheme));

const mapStateToProps = (state) => ({
  auth: state.auth,
});

// memo lets you skip re-rendering a component when its props are unchanged
export const Dashboard = React.memo((props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { auth: { decodedToken } } = props;
  const [loggedOnce, setLoggedOnce] = useState(props.auth.token !== undefined);

  // ***** Webpack hot reload handling *****
  useEffect(() => {
    if (module.hot) {
      module.hot.addStatusHandler((status) => {
        if (status === 'check') {
          store.dispatch(setLoading({ message: 'Chargement en cours...',
            open: true }));
        } else if (status === 'idle') {
          store.dispatch(setLoading({ open: false }));
        }
      });
    }
  }, []);

  useEffect(() => {
    props.hideLoader();
    if (loggedOnce === false
      && props.auth.token
      && props.auth.token !== undefined
    ) {
      setLoggedOnce(true);
    }
    if (props.auth.token && Object.keys(props.auth).length === 0) {
      setLoggedOnce(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.auth]);

  const deconnexion = () => {
    navigate('/login');
    props.dispatch(logout());
  };

  const autoriseRoute = decodedToken && loggedOnce
    ? routers(decodedToken)
    : [];
  return (
    <div style={{ height: '100%' }}>
      <ThemeProvider theme={theme}>
        <Header
          user={decodedToken}
          deconnexion={deconnexion}
          navigate={navigate}
          pageName={location.pathname}
        />
        <Routes>
          <Route path={'/login'} element={<Login open />} />
          <Route
            path={'/resetPassword/:token'}
            element={<ResetPassword />}
          />
          {loggedOnce ? (
            autoriseRoute.map((e) => (
              <Route
                exact
                key={`${e.path}-${e.component.name}`}
                {...e}
                element={<Suspense fallback={<div>Chargement en cours...</div>}>
                  <e.component
                    enabled={autoriseRoute}
                    {...props}
                    {...e.componentProps}
                  />
                </Suspense>}
              />
            ))
          ) : (
            <Route path='*' element={
              <Navigate
                to={'/login'}
                state={{
                  from: props.location === '/login'
                    ? '/'
                    : props.location,
                }}
              />
            } />
          )}
          <Route path='*' element={<Page404 />} />
        </Routes>
        <Notifications />
        <DialogManager />
        <LoadingManager />
      </ThemeProvider>
    </div>
  );
});

export default compose(
  connect(mapStateToProps),
  withMediaQuery()
)(Dashboard);
